import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tooltipSource']

  tooltipSourceTargetConnected(element) {
    const tooltipEl = $(element)
    tooltipEl?.tooltip({ trigger: 'hover' })
    tooltipEl?.click(function () { tooltipEl.tooltip('hide') })
  }
}
